(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smx-ai-advisor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smx-ai-advisor')) {
  customElements.define('smx-ai-advisor', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('[data-smx-copy]');
      const textarea = this.querySelector('textarea');
      const status = this.querySelector('[role="status"]');
      const details = this.querySelector('.smx-ai__prompt');
      if (!button || !textarea || !status) return;
      button.hidden = false;
      const copyPrompt = async (provider) => {
        try {
          await navigator.clipboard.writeText(textarea.value);
          status.textContent = provider ? this.dataset.pasteMessage.replace('[provider]', provider) : this.dataset.copied;
        } catch {
          details.open = true;
          textarea.focus();
          textarea.select();
          status.textContent = this.dataset.copyFallback;
        }
      };
      button.addEventListener('click', () => copyPrompt());
      this.querySelectorAll('[data-smx-copy-open]').forEach(link => {
        link.addEventListener('click', () => copyPrompt(link.dataset.smxCopyOpen));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smx-bm-contents"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smx-ratgeber')) {
  customElements.define('smx-ratgeber', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.viewportQuery?.addEventListener('change', this.applyDisclosure);
        this.applyDisclosure?.();
        return;
      }
      this.initialized = true;
      const initialize = () => {
        const list = this.querySelector('ol');
        const disclosure = this.querySelector('details');
        if (!list || !disclosure) return;
        const source = this.dataset.sourceId && document.getElementById(this.dataset.sourceId);
        if (source && this.dataset.mode !== 'manual') {
          let headings = [...source.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
          if (headings.length < 2) headings = [...source.querySelectorAll('h2,h3')].filter(heading => heading.textContent.trim());
          if (!headings.length) headings = [...source.querySelectorAll('p > strong:only-child, p > b:only-child')].filter(heading => {
            const text = heading.textContent.trim();
            return text.length > 2 && text.length <= 120 && /[A-Za-zÄÖÜäöüß]/.test(text) && text === heading.parentElement.textContent.trim();
          }).map(heading => heading.parentElement);
          const fragment = document.createDocumentFragment();
          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = `smx-page-heading-${index + 1}-${this.dataset.sectionId}`;
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent.trim();
            item.append(link);
            fragment.append(item);
          });
          list.prepend(fragment);
        }
        this.hidden = !list.children.length;
        this.viewportQuery = window.matchMedia('(min-width: 768px)');
        this.applyDisclosure = () => { disclosure.open = this.viewportQuery.matches ? this.dataset.openDesktop === 'true' : this.dataset.openMobile === 'true'; };
        this.applyDisclosure();
        this.viewportQuery.addEventListener('change', this.applyDisclosure);
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || !this.contains(link)) return;
          let id;
          try { id = decodeURIComponent(link.hash.slice(1)); } catch { return; }
          const target = document.getElementById(id);
          if (!target) return;
          let details = target.closest('details');
          while (details) {
            details.open = true;
            details = details.parentElement?.closest('details');
          }
        });
        if (window.Shopify?.designMode) {
          list.querySelectorAll('a[href^="#"]').forEach(link => {
            let id;
            try { id = decodeURIComponent(link.hash.slice(1)); } catch { return; }
            if (document.getElementById(id)) return;
            const warning = document.createElement('small');
            warning.className = 'smx-bm-contents__warning text-sm';
            warning.textContent = this.dataset.missingTargetLabel;
            link.after(warning);
          });
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
      else initialize();
    }
    disconnectedCallback() {
      this.viewportQuery?.removeEventListener('change', this.applyDisclosure);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smx-help-card"] && !Shopify.designMode) return;
  try {
    (()=>{const s='[data-sm-help-card]',w={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6},timers=new WeakMap(),parse=v=>{const m=/^([01]\d|2[0-3]):([0-5]\d)$/.exec(v||'');return m?Number(m[1])*60+Number(m[2]):null},zoned=(d,t)=>{try{const p=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:t,weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(d).map(x=>[x.type,x.value]));return{day:w[p.weekday],minutes:Number(p.hour)*60+Number(p.minute)}}catch(e){return null}},open=c=>{if(c.dataset.mode==='online')return true;if(c.dataset.mode==='offline')return false;const a=parse(c.dataset.openAt),b=parse(c.dataset.closeAt),days=new Set((c.dataset.openDays||'').split(',').filter(Boolean).map(Number)),now=zoned(new Date(),c.dataset.timezone||'Europe/Berlin');if(a===null||b===null||a===b||!now||!days.size)return false;if(a<b)return days.has(now.day)&&now.minutes>=a&&now.minutes<b;return days.has(now.day)&&now.minutes>=a||days.has((now.day+6)%7)&&now.minutes<b},update=c=>{const on=open(c),label=c.querySelector('[data-sm-help-status]');c.classList.toggle('sm-help-card--online',on);c.dataset.status=on?'online':'offline';if(label)label.textContent=on?c.dataset.onlineLabel:c.dataset.offlineLabel},start=c=>{const old=timers.get(c);if(old)clearInterval(old);update(c);timers.set(c,setInterval(()=>update(c),30000))},all=(root=document)=>root.querySelectorAll(s).forEach(start);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all(),{once:true});else all();document.addEventListener('visibilitychange',()=>{if(!document.hidden)all()});document.addEventListener('shopify:section:load',e=>all(e.target))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smx-mobile-shopping-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  const launcher = document.querySelector('[data-smx-mobile-chat]');
  if (!launcher || launcher.dataset.smxMobileChatInit === 'true' || new URLSearchParams(window.location.search).get('view') === 'configurator') return;
  launcher.dataset.smxMobileChatInit = 'true';
  const mobile = window.matchMedia('(max-width: 767.98px)');
  let activeApi;
  let chatOpen = false;
  let nativeHidden = false;
  function sync() {
    if (!activeApi) return;
    launcher.hidden = !mobile.matches || chatOpen;
    if (mobile.matches && !chatOpen && !nativeHidden) {
      nativeHidden = true;
      activeApi.hide();
    } else if ((!mobile.matches || chatOpen) && nativeHidden) {
      nativeHidden = false;
      activeApi.show();
    }
  }
  function ready() {
    const api = window.tidioChatApi;
    if (!api || activeApi === api || !['on','show','hide','open'].every(method => typeof api[method] === 'function')) return;
    activeApi = api;
    api.on('beforeOpen', () => {
      if (chatOpen) return;
      chatOpen = true;
      sync();
    });
    api.on('open', () => {
      if (chatOpen) return;
      chatOpen = true;
      sync();
    });
    api.on('close', () => {
      if (!chatOpen) return;
      chatOpen = false;
      sync();
      if (mobile.matches) launcher.focus({ preventScroll: true });
    });
    sync();
  }
  launcher.addEventListener('click', () => {
    if (!activeApi) return;
    chatOpen = true;
    sync();
    activeApi.open();
  });
  mobile.addEventListener('change', sync);
  document.addEventListener('tidioChat-ready', ready);
  if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') window.tidioChatApi.on('ready', ready);
})();
  } catch(e) { console.error(e); }
})();

})();
